import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight, ChevronRight } from "lucide-react";
import SEOHead from "../components/SEOHead";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingCTA from "../components/FloatingCTA";
import { blogPosts } from "../data/blogPosts";

export const Blog = () => {
  return (
    <>
      <SEOHead
        title="Blog Serrurerie – Conseils et astuces | Serrurier Lieusaint"
        description="Découvrez nos articles de blog sur la serrurerie : conseils, astuces, guides pratiques pour sécuriser votre domicile et gérer les urgences serrurerie."
        type="Blog"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="py-16 md:py-24 bg-zinc-950">
          <div className="container-custom">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm text-zinc-400 mb-8">
              <Link to="/" className="hover:text-yellow-400 transition-colors">Accueil</Link>
              <ChevronRight className="w-4 h-4" />
              <span className="text-yellow-400">Blog</span>
            </nav>

            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-6xl font-bold uppercase tracking-tight text-white mb-6 font-heading" data-testid="blog-title">
                Blog Serrurerie
                <span className="block text-yellow-400 text-2xl md:text-4xl mt-2">
                  Conseils et astuces
                </span>
              </h1>
              <p className="text-lg text-zinc-300">
                Découvrez nos articles pour tout savoir sur la serrurerie : comment réagir en cas d'urgence, 
                sécuriser votre domicile, choisir la bonne serrure et éviter les arnaques.
              </p>
            </div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post, index) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className={`group bg-white border border-zinc-200 rounded-sm overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-zinc-300 ${
                    index === 0 ? 'md:col-span-2 lg:col-span-2' : ''
                  }`}
                  data-testid={`blog-card-${post.slug}`}
                >
                  {/* Image */}
                  <div className={`relative overflow-hidden ${index === 0 ? 'h-64' : 'h-48'}`}>
                    <img
                      src={post.image}
                      alt={post.imageAlt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-zinc-900/60 to-transparent" />
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    {/* Meta */}
                    <div className="flex items-center gap-4 text-sm text-zinc-500 mb-3">
                      <div className="flex items-center gap-1">
                        <Calendar className="w-4 h-4" />
                        {new Date(post.date).toLocaleDateString('fr-FR', { 
                          day: 'numeric', 
                          month: 'long', 
                          year: 'numeric' 
                        })}
                      </div>
                      <div className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        {post.readTime}
                      </div>
                    </div>

                    {/* Title */}
                    <h2 className={`font-bold uppercase tracking-tight text-zinc-900 mb-3 font-heading group-hover:text-yellow-500 transition-colors ${
                      index === 0 ? 'text-2xl' : 'text-xl'
                    }`}>
                      {post.title}
                    </h2>

                    {/* Excerpt */}
                    <p className="text-zinc-600 text-sm mb-4 line-clamp-2">
                      {post.excerpt}
                    </p>

                    {/* Read more */}
                    <div className="flex items-center text-yellow-500 font-medium text-sm uppercase tracking-wide">
                      Lire l'article
                      <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-2" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingCTA />
    </>
  );
};

export default Blog;
